import React, { useEffect, useState } from 'react';
import { TextField, TextFieldProps } from '@mui/material';

type DebouncedTextFieldProps = TextFieldProps & {
    onDebounceChange: (value: string) => void;
    debounceValue: string;
    debounceTime?: number;
};

export function DebouncedTextField(props: DebouncedTextFieldProps) {
    const { onDebounceChange, debounceValue, debounceTime = 1500 } = props ?? {};

    const [inputValue, setInputValue] = useState<string>(debounceValue);

    useEffect(() => {
        setInputValue(debounceValue);
    }, [debounceValue]);

    useEffect(() => {
        // Using setTimeout() here only for debouncing purposes to avoid unnecessary API calls
        const timeout = setTimeout(() => {
            onDebounceChange(inputValue);
        }, debounceTime);

        return () => clearTimeout(timeout);
    }, [inputValue]);

    return <TextField {...props} value={inputValue} onChange={(event) => setInputValue(event.target.value)} />;
}
